<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in childrenRoutes"
          :key="route.path"
          :item="route"
          :base-path="resolvePath(route.path)"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'
import path from 'path'

export default {
  components: { SidebarItem, Logo },
  data() {
    return {
    }
  },
  computed: {
    basePath() {
      const route = this.$route
      const { path } = route
      console.log('path', path)
      const arr = path.split('/')
      return arr[1]
    },
    ...mapGetters([
      'permission_routes',
      'sidebar',
      'childrenRoutes'
    ]),
    activeMenu() {
      const route = this.$route
      const { path } = route
      const arr = path.split('/')
      // if set path, the sidebar will highlight the path you set
      // if (meta.activeMenu) {
      //   return meta.activeMenu
      // }
      const realPath = arr[arr.length - 1]
      return realPath
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  created() {

  },
  methods: {
    resolvePath(routePath) {
      console.log('basePath', this.basePath)
      return path.resolve(this.basePath, routePath)
    }
  }
}
</script>
